export default {
  SMART_INVEST: 'smart_invest',
  BUILD_YOUR_OWN: 'build_your_own',
};
